import React, {useContext, useEffect, useState} from 'react';
import {Backdrop} from '@mui/material';
import {DataContext} from '../../contexts/dataContext';
import {deferComponent} from '../Deferred/deferComponent';
import {loadGoogleLibrary} from '../../services/googleMapsLoader';
import {translateService} from '../../services/TranslateService';

const loadMap = () => import('./googleMaps');
// The fallback stands in for `.default-map-image`, which is `height: 100vh` — both in the
// pre-search placeholder below and inside googleMaps once the chunk arrives. A px value
// here collapses the column to that height and springs back, on the element real-user data
// already reports as the worst shift on the desktop homepage. It is also `.stickyDiv`, like
// the placeholder's wrapper below and googleMaps' own: measured on www.24rent.fi on 22 Sep
// 2026, a plain fallback left the column unstuck for the ~300 ms the chunk took to arrive.
const Map = deferComponent(loadMap, '100vh', 'stickyDiv');

// Called alongside the search request, never awaited by search itself.
export function prepareDesktopMap() {
    window.dispatchEvent(new Event('rrm-search-start'));
    void Promise.all([loadMap(), loadGoogleLibrary('maps'), loadGoogleLibrary('marker')]).catch(() => {
        // The visible map owns the error/retry UI. Search remains independent.
    });
}

export default function DeferredMap(props: {lat: number; lng: number; width: string}) {
    const context = useContext(DataContext);
    const [searchStarted, setSearchStarted] = useState(!!context.vehicle);
    useEffect(() => {
        const start = () => setSearchStarted(true);
        window.addEventListener('rrm-search-start', start);
        return () => window.removeEventListener('rrm-search-start', start);
    }, []);
    if (context.mapCanInit && (context.mobileDevice || searchStarted)) return <Map {...props}/>;
    const showOverlay = !context.oneWayRes && context.showDefaultResults;
    return <div className="stickyDiv">
        <div className="position-relative">
            <Backdrop
                sx={{color: '#fbb040', zIndex: (theme) => theme.zIndex.drawer + 1005, position: 'absolute'}}
                open={!!showOverlay}>
                <button className="btn btn-primary btn-outline-primary btn-all font-weight-bold loginFirst"
                        onClick={() => {
                            document.getElementById('searchbox-label')?.scrollIntoView({behavior: 'smooth', block: 'center'});
                            (document.querySelector('.searchbox-input') as HTMLElement)?.focus();
                        }}>
                    {translateService.translate('vehicleSearch1.selectLocationAndDate')}
                </button>
            </Backdrop>
            <div className={context.oneWayRes ? 'default-oneway-map-image' : 'default-map-image'}/>
        </div>
    </div>;
}
